export default "__VITE_ASSET__Brrnmmiz__"